
<template>
  <div>
    <van-nav-bar
      :fixed="true"
      :title="setpList[step]"
      left-arrow
      @click-left="handlerStep(-1)"
      @click-right="gonext()"
      :right-text="setpList[step + 1]"
    />

    <!-- <van-nav-bar
      class="navbar"
      :fixed="true"
      title="认购信息"
      left-arrow
      @click-left="$router.back()"
    /> -->

    <van-cell class="step">
      <van-steps :active="active">
        <van-step>选择客户</van-step>
        <van-step>首业主信息</van-step>
        <van-step>业主列表信息</van-step>
        <!-- <van-step>完成</van-step> -->
      </van-steps>
    </van-cell>

    <clist v-if="active == 0" @click="onUserSelect" :req="{}"></clist>

    <!-- <datailinupt v-if="active == 1" :initdata="user" :config="list"/> -->
    <van-form @submit="onSubmit" name="userinfo" ref="userinfo">
      <baseinfo v-if="active == 1" :useMessage="user" />

      <famely v-if="active == 2" :useMessage="user" />

      <div style="margin: 16px">
        <van-row>
          <van-col span="12">
            <van-button round block @click.prevent="$router.back()"
              >取消</van-button
            >
          </van-col>
          <van-col span="12">
            <van-button round block type="info" native-type="submit"
              >提交</van-button
            >
          </van-col>
        </van-row>
      </div>
    </van-form>
  </div>
</template>
<script>
import clist from "../customer/clist/index";

import baseinfo from "./baseinfo";
import famely from "./famely";
export default {
  name: "commodityList",
  components: { clist, baseinfo, famely },
  props: {
    // commodity: {
    //   type: Object,
    //   default: () => {
    //     return {};
    //   },
    // },
  },

  data() {
    return {
      active: 0,
      user: {},
      setpList: ["客户资料", "业主列表"],
    };
  },

  watch: {
    // commodity(newV,oldV) {
    //   this.onRefresh();
    // }
  },
  methods: {
    //提交信息
    onSubmit() {
      console.log(this.user);
      if (this.user.业主列表 == undefined)
        this.user.业主列表 = [{}, {}, {}, {}];
      this.$request.customerSave(this.user).then((res) => {
        if (res.code == 0) {
          this.$toast({
            message: "保存成功",
          });
          this.active += 1;
          if (this.active == 3) this.$router.back();
        } else {
          this.$toast({
            message: res.msg,
          });
        }
      });

      // this.restUseMessge();
    },
    onUserSelect(user) {
      this.active = 1;
      if (user.国籍 == undefined) user.国籍 = "中国";
      if (user.证件类型 == undefined) user.证件类型 = "身份证";
      if (user.客户类型 == undefined) user.客户类型 = "个人";

      this.user = user;
    },
    //   onCancel() {
    //     this.pagenum = 1;
    //     this.searchStr = "";
    //     this.getList();
    //   },
    //   onRefreshStart() {
    //     this.pagenum = 1;
    //     this.getList();
    //   },
    //   // 获取数据
    //   getList() {
    //     this.loading = true;
    //     let data = {
    //       paging: {
    //         limit: 10,
    //         page: this.pagenum,
    //       },
    //       req: {},
    //     };

    //     if (this.searchStr != "") {
    //       data.req.username = { $regex: this.searchStr };
    //     }
    //     this.$request
    //       .customerList(data)
    //       .then((res) => {
    //         console.log(res);
    //         this.loading = false;
    //         if (res.code == 0) {
    //           if (this.pagenum == 1) {
    //             this.list = res.data.items;
    //           } else {
    //             this.list = this.list.concat(res.data.items);
    //           }
    //           this.dataList = this.list;
    //           this.total = res.data.total;
    //           if (this.dataList.length >= this.total) {
    //             this.finished = true;
    //           }
    //         }
    //       })
    //       .catch(() => {
    //         this.finished = true;
    //       });
    //   },

    //   onRefresh() {
    //     this.pagenum = 1;
    //     this.finished = false;

    //     this.getList();
    //     this.refreshing = false;
    //   },
    //   onLoad() {
    //     this.pagenum++;
    //     this.getList();
    //   },
    // },
    // mounted() {
    //   this.$nextTick(() => {
    //     this.getList();
    //     // this.$store.dispatch("setCacheObjFirstLoad", false);
    //     // this.onRefresh()
    //   });
  },
};
</script>
<style scoped lang="less">
.navbar {
}
.step {
  margin-top: 50px;
}
#commodityList {
  margin-top: 10px;
  padding: 0 10px;

  .commodityBox {
    flex-wrap: wrap;
    font-size: 14px;

    .commodityContainer {
      background-color: #fff;
      margin-bottom: 10px;
      padding: 10px !important;
      border-radius: 20px;

      // box-shadow: #666 5px 5px 5px;
      .textBox {
        margin: 5px 0px 5px 0px;

        .colon {
          display: inline-block;
          margin: 0 4px;
          color: black;
        }

        .block {
          display: inline-block;
          width: 30px;
          color: #fff;
          font-size: 12px;
          text-align: center;
          background-color: #ee0a24;
        }

        .batch {
          color: green;
        }

        .batch p {
          margin: 3px;
        }
      }
    }
  }
}
</style>